// extracted by mini-css-extract-plugin
export default {"root":"ContactBroker_root__XbmII","boldMessage":"ContactBroker_boldMessage__aZo+y","message":"ContactBroker_message__6863a","link":"ContactBroker_link__c8R4I"};